import { useState } from "react";
import { useAuth } from "../lib/api.jsx";

export default function Login() {
  const { api, login } = useAuth();
  const [f, setF] = useState({ login: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const go = async () => {
    setBusy(true); setErr("");
    try {
      const r = await api("login", { method: "POST", body: f });
      login(r.token, r.name);
    } catch (e) {
      setErr(e.message);
    }
    setBusy(false);
  };

  return (
    <div className="login-screen">
      <div className="login-wrap">
        <div className="pane">
          <h2>Admin sign in</h2>
          <p className="muted" style={{ marginTop: 4 }}>Sign in with an admin account to manage subscribers.</p>
          <label>Email or mobile</label>
          <input autoFocus value={f.login} onChange={(e) => setF({ ...f, login: e.target.value })} />
          <label>Password</label>
          <input
            type="password"
            value={f.password}
            onChange={(e) => setF({ ...f, password: e.target.value })}
            onKeyDown={(e) => e.key === "Enter" && go()}
          />
          {err && <p className="err" style={{ marginTop: 10 }}>{err}</p>}
          <div className="bar">
            <button className="btn" style={{ width: "100%" }} disabled={busy} onClick={go}>{busy ? "Signing in..." : "Sign in"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
